const o = {
  name: "Collections",
  dimensions: { width: 20, height: 24 },
  content: `
        <path d="M13 7.5V3.5C13 2.39543 12.1046 1.5 11 1.5H3C1.89543 1.5 1 2.39543 1 3.5V11.5C1 12.6046 1.89543 13.5 3 13.5H7" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/><rect x="7" y="7.5" width="12" height="12" rx="2" fill="none" stroke="currentColor" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
    `
};
export {
  o as Collections
};
